<template>
    <v-pagination v-bind="$attrs" class="v-pagination--filled rounded-0"></v-pagination>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
